module.exports = __webpack_public_path__ + "media/images/icons/icon-cup-98db6c6deb30e22bb0171727b9aa549e.png";